import { checkRole } from '@/utils/acl'

import type { UserRoles } from '../../../types'
import type { CoreGetters, CoreState } from '../../types'

export const isActiveDemoAccount = (
  state: CoreState,
  getters: CoreGetters,
  _globalState: unknown,
  globalGetters: Record<string, string>
): boolean | undefined => {
  const locations = getters['brand/active/locations']

  const userRole = globalGetters['session/role'] as UserRoles

  if (checkRole(userRole, 'pb:*')) {
    return false
  }

  if (locations?.length) {
    return !locations.some(({ id }) => {
      const billingSetting = state.billingSettings.find(
        (billingSetting) => billingSetting.locationId === id
      )

      return billingSetting?.tier === 'standard'
    })
  }

  return undefined
}
